import { IEntityMetaData, IPropretyAttribute } from "../../_models/IEntityMetaData";
import { GenericEntityBase, KeyType } from "../../_models/GenericEntityBase";
import { PropretyAttributes, NestedProperty, NavigationProperty } from "../../decorators/EntityDecorators";
import { PointOfService } from "./PointOfService.model";
import { CovidTranslation } from "./navigation-entities/CovidTranslation.model";
import { Translation } from "./navigation-entities/Translation.model";

export class Covid extends GenericEntityBase<number> {
  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.KeyProperty,
      IPropretyAttribute.Readonly
    ]
  })
  id: number = GenericEntityBase.GetDefaultId(KeyType.number);

  description?: string;

  numero?: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  fK_PointOfService!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  notificationExclusion!: boolean;

  fK_Parent?: number;

  parentValue?: boolean;

  @NestedProperty({ TargetType: PointOfService })
  pointOfService?: PointOfService;

  @NestedProperty({ TargetType: Covid })
  parent?: Covid;

  @NavigationProperty({ TargetType: Covid })
  children?: Covid[];

  // @NavigationProperty({ TargetType: CovidTranslation })
  // covidTranslations?: CovidTranslation[];

  @NavigationProperty({ TargetType: Translation })
  translations?: Translation[];

  GetType(): IEntityMetaData {
    return Covid.getMetaData();
  }
}
